import * as Yup from 'yup'

import { getPhoneSelectFormikFieldValidator } from '../../../../Phone'

import { LOGIN_FORM_PHONE_NUMBER_FIELD_NAME_PHONE } from './LoginFormPhoneNumber.constants'

export function getLoginFormPhoneNumberValidationSchema() {
  return Yup.object({
    [LOGIN_FORM_PHONE_NUMBER_FIELD_NAME_PHONE]:
      getPhoneSelectFormikFieldValidator().required(true),
  })
}
